/* AFS B2B — collection filtering/sorting via Section Rendering API,
   list/grid view toggle, mobile filter drawer. */
(function () {
  'use strict';

  var form = document.getElementById('FacetsForm');
  var results = document.getElementById('CollectionResults');
  if (!form || !results) return;

  var sectionId = results.getAttribute('data-section-id');
  var debounce = null;

  function serialize() {
    var params = new URLSearchParams(new FormData(form));
    // Drop empty values so URLs stay clean/canonical-friendly
    var clean = new URLSearchParams();
    params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
    return clean.toString();
  }

  function renderFromUrl(url, updateHistory) {
    results.setAttribute('aria-busy', 'true');
    fetch(url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + sectionId)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['CollectionResults', 'ActiveFacets', 'FacetsForm', 'ResultsCount'].forEach(function (id) {
          var incoming = doc.getElementById(id);
          var current = document.getElementById(id);
          if (incoming && current) current.innerHTML = incoming.innerHTML;
        });
        results.removeAttribute('aria-busy');
        if (updateHistory) window.history.pushState({}, '', url);
        bindFacetInputs();
        var count = document.getElementById('ResultsCount');
        if (count) count.setAttribute('tabindex', '-1');
      })
      .catch(function () {
        results.removeAttribute('aria-busy');
        window.AFSToast && window.AFSToast(results.getAttribute('data-error-text') || 'Unable to update results.', { tone: 'error' });
      });
  }

  function apply() {
    var qs = serialize();
    var url = window.location.pathname + (qs ? '?' + qs : '');
    renderFromUrl(url, true);
  }

  function bindFacetInputs() {
    var f = document.getElementById('FacetsForm');
    if (!f) return;
    f.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener('change', apply);
    });
    f.querySelectorAll('input[type="number"], input[type="text"]').forEach(function (input) {
      input.addEventListener('change', function () {
        window.clearTimeout(debounce);
        debounce = window.setTimeout(apply, 300);
      });
    });
  }
  bindFacetInputs();

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort-select]')) {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', e.target.value);
      renderFromUrl(window.location.pathname + '?' + params.toString(), true);
    }
  });

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-facet-remove]');
    if (chip) {
      e.preventDefault();
      renderFromUrl(chip.getAttribute('href'), true);
    }
    var toggle = e.target.closest('[data-facets-toggle]');
    if (toggle) {
      var facets = document.getElementById('Facets');
      if (facets) {
        var openNow = facets.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(openNow));
      }
    }
    var view = e.target.closest('[data-view]');
    if (view) {
      var grid = document.querySelector('.product-grid');
      if (!grid) return;
      var mode = view.getAttribute('data-view');
      grid.classList.toggle('product-grid--list', mode === 'list');
      document.querySelectorAll('[data-view]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === view));
      });
      try { localStorage.setItem('afs:plp-view', mode); } catch (err) { /* noop */ }
    }
  });

  // Restore preferred view
  try {
    if (localStorage.getItem('afs:plp-view') === 'list') {
      var grid = document.querySelector('.product-grid');
      var listBtn = document.querySelector('[data-view="list"]');
      if (grid && listBtn) {
        grid.classList.add('product-grid--list');
        document.querySelectorAll('[data-view]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === listBtn));
        });
      }
    }
  } catch (e) { /* noop */ }

  window.addEventListener('popstate', function () {
    renderFromUrl(window.location.pathname + window.location.search, false);
  });
})();
